import ccCommon from '@/common/i18n/de/common/common.json';
import coreCommon from '@simpleforyou/client-core/dist/i18n/de/common.json';
import ccTable from '@simpleforyou/client-core/dist/i18n/de/form/table.json';
import ccEditor from '@simpleforyou/client-core/dist/i18n/de/form/editor.json';
import ccForm from '@simpleforyou/client-core/dist/i18n/de/form/form.json';

import coachingEditor from '@/common/i18n/de/editor.json';
import coachingForm from '@/common/i18n/de/form.json';

const common = Object.assign({}, ccCommon, coreCommon);

const editor = Object.assign({}, ccEditor, coachingEditor);
const form = Object.assign({}, ccForm, coachingForm);

// layout
import login from '@/common/i18n/de/common/login.json' with {type: 'json'};
import register from '@/common/i18n/de/common/register.json' with {type: 'json'};
import passwordForgot from '@/common/i18n/de/common/passwordForgot.json' with {type: 'json'};
import passwordForgotConfirm from '@/common/i18n/de/common/passwordForgotConfirm.json' with {type: 'json'};
import password from '@/common/i18n/de/common/password.json' with {type: 'json'};
import coaching from '@/common/i18n/de/common/coaching.json' with {type: 'json'};
import calendar from '@/common/i18n/de/common/calendar.json' with {type: 'json'};
import appBeta from '@/common/i18n/de/common/appBeta.json' with {type: 'json'};
import trial from '@/common/i18n/de/common/trial.json' with {type: 'json'};
import types from '@/common/i18n/de/common/types.json' with {type: 'json'};
import routes from '@/common/i18n/de/layout/routes.json' with {type: 'json'};
import titles from '@/common/i18n/de/layout/titles.json' with {type: 'json'};
import navigation from '@/common/i18n/de/layout/navigation.json' with {type: 'json'};
import layoutTour from '@/common/i18n/de/layout/tour.json' with {type: 'json'};
// liveCoaching
import liveCoachingList from '@/common/i18n/de/liveCoaching/list.json' with {type: 'json'};
import liveCoachingForm from '@/common/i18n/de/liveCoaching/form.json' with {type: 'json'};
// module
import moduleList from '@/common/i18n/de/module/list.json' with {type: 'json'};
import moduleForm from '@/common/i18n/de/module/form.json' with {type: 'json'};
import modulePreview from '@/common/i18n/de/module/preview.json' with {type: 'json'};
import moduleChapter from '@/common/i18n/de/module/chapter.json' with {type: 'json'};
import moduleChapterStep from '@/common/i18n/de/module/step.json' with {type: 'json'};
// customer
import customerList from '@/common/i18n/de/customer/list.json' with {type: 'json'};
import customerForm from '@/common/i18n/de/customer/form.json' with {type: 'json'};
// user
import userList from '@/common/i18n/de/user/list.json' with {type: 'json'};
import userForm from '@/common/i18n/de/user/form.json' with {type: 'json'};
import userProgress from '@/common/i18n/de/user/progress.json' with {type: 'json'};
import userModule from '@/common/i18n/de/user/module.json' with {type: 'json'};
import userDiary from '@/common/i18n/de/user/diary.json' with {type: 'json'};
import userProfile from '@/common/i18n/de/user/profile.json' with {type: 'json'};
import userSwitch from '@/common/i18n/de/user/switch.json' with {type: 'json'};
import userDashboard from '@/common/i18n/de/user/dashboard.json' with {type: 'json'};
// recipe
import recipe from '@/common/i18n/de/recipe/recipe.json' with {type: 'json'};
import cookbook from '@/common/i18n/de/recipe/cookbook.json' with {type: 'json'};
// diary
import diaryList from '@/common/i18n/de/diary/list.json' with {type: 'json'};
import diaryForm from '@/common/i18n/de/diary/form.json' with {type: 'json'};
import diaryShow from '@/common/i18n/de/diary/show.json' with {type: 'json'};
// notification
import notificationList from '@/common/i18n/de/notification/list.json' with {type: 'json'};
import notificationForm from '@/common/i18n/de/notification/form.json' with {type: 'json'};
// maintenance
import maintenanceList from '@/common/i18n/de/maintenance/list.json' with {type: 'json'};
import maintenanceForm from '@/common/i18n/de/maintenance/form.json' with {type: 'json'};
import maintenanceBanner from '@/common/i18n/de/maintenance/banner.json' with {type: 'json'};
import maintenanceVideoMetadataBackfill from '@/common/i18n/de/maintenance/videoMetadataBackfill.json' with {type: 'json'};
// settings
import settings from '@/common/i18n/de/settings/settings.json' with {type: 'json'};
// agreement
import agreement from '@/common/i18n/de/agreement/agreement.json' with {type: 'json'};
// course
import courseList from '@/common/i18n/de/course/list.json' with {type: 'json'};
import courseForm from '@/common/i18n/de/course/form.json' with {type: 'json'};
// statistic
import statisticList from '@/common/i18n/de/statistic/list.json' with {type: 'json'};
import statisticDevice from '@/common/i18n/de/statistic/device.json' with {type: 'json'};
import statisticUser from '@/common/i18n/de/statistic/user.json' with {type: 'json'};
import statisticOnlineTime from '@/common/i18n/de/statistic/userOnlineTime.json' with {type: 'json'};
import statisticOverview from '@/common/i18n/de/statistic/overview.json' with {type: 'json'};
import statisticClients from '@/common/i18n/de/statistic/clients.json' with {type: 'json'};
import statisticClientDetail from '@/common/i18n/de/statistic/clientDetail.json' with {type: 'json'};
import statisticAtRisk from '@/common/i18n/de/statistic/atRisk.json' with {type: 'json'};
import statisticFunnel from '@/common/i18n/de/statistic/funnel.json' with {type: 'json'};
import statisticRetention from '@/common/i18n/de/statistic/retention.json' with {type: 'json'};
import statisticActivation from '@/common/i18n/de/statistic/activation.json' with {type: 'json'};
import statisticDiaryResponse from '@/common/i18n/de/statistic/diaryResponse.json' with {type: 'json'};
import statisticBandTrend from '@/common/i18n/de/statistic/bandTrend.json' with {type: 'json'};
import statisticLifecycle from '@/common/i18n/de/statistic/lifecycle.json' with {type: 'json'};
// coachingProfile
import coachingProfile from '@/common/i18n/de/coachingProfile/coachingProfile.json' with {type: 'json'};
// fileSystem
import fileSystemList from '@/common/i18n/de/fileSystem/list.json' with {type: 'json'};
import fileSystemForm from '@/common/i18n/de/fileSystem/form.json' with {type: 'json'};
// changelog
import changelogList from '@/common/i18n/de/changelog/list.json' with {type: 'json'};
import changelogForm from '@/common/i18n/de/changelog/form.json' with {type: 'json'};
import changelogWhatsNew from '@/common/i18n/de/changelog/whatsNew.json' with {type: 'json'};
// tiptap
import tiptap from '@/common/i18n/de/common/tiptap.json' with {type: 'json'};

// feedback
import feedback from '@/common/i18n/de/feedback.json' with {type: 'json'};

export const deMessages = {
  common,
  login,
  register,
  passwordForgot,
  passwordForgotConfirm,
  password,
  coaching,
  calendar,
  appBeta,
  trial,
  types,
  routes,
  titles,
  navigation,
  feedback,
  layout: {
    tour: layoutTour,
  },
  table: ccTable,
  form,
  editor,
  liveCoaching: {
    ...liveCoachingList,
    form: liveCoachingForm,
  },
  module: {
    ...moduleList,
    form: moduleForm,
    preview: modulePreview,
    chapter: {
      ...moduleChapter,
      step: moduleChapterStep,
    },
  },
  customer: {
    ...customerList,
    form: customerForm,
  },
  user: {
    ...userList,
    form: userForm,
    progress: userProgress,
    module: userModule,
    diary: userDiary,
    profile: userProfile,
    switch: userSwitch,
    dashboard: userDashboard,
  },
  recipe: {
    ...recipe,
    cookbook,
  },
  diary: {
    ...diaryList,
    form: diaryForm,
    show: diaryShow,
  },
  notification: {
    ...notificationList,
    form: notificationForm,
  },
  maintenance: {
    ...maintenanceList,
    form: maintenanceForm,
    banner: maintenanceBanner,
    videoMetadataBackfill: maintenanceVideoMetadataBackfill,
  },
  settings: {
    ...settings,
  },
  agreement: {
    ...agreement,
  },
  course: {
    ...courseList,
    form: courseForm,
  },
  statistic: {
    ...statisticList,
    device: statisticDevice,
    user: statisticUser,
    userOnlineTime: statisticOnlineTime,
    overview: statisticOverview,
    clients: statisticClients,
    clientDetail: statisticClientDetail,
    atRisk: statisticAtRisk,
    funnel: statisticFunnel,
    retention: statisticRetention,
    activation: statisticActivation,
    diaryResponse: statisticDiaryResponse,
    bandTrend: statisticBandTrend,
    lifecycle: statisticLifecycle,
  },
  coachingProfile,
  fileSystem: {
    ...fileSystemList,
    form: fileSystemForm,
  },
  changelog: {
    ...changelogList,
    form: changelogForm,
    whatsNew: changelogWhatsNew,
  },
  tiptap,
};
